<template>
  <div class="content">
    <div class="member-center">
      <div class="part-top">
        <!-- info-card -->
        <div class="info-card-wrap">
          <InfoCard :info="customerInfo" :list="privilegeList"></InfoCard>
        </div>
        <!-- integral -->
        <div class="integral-wrap">
          <div class="part-title fix">
            <div class="integral-left l">
              <i class="icon icon-integral l"></i>
              <h3 class="l">赚积分</h3>
              <div class="current-integral l">
                有效积分：<router-link
                  tag="span"
                  class="number-font cur"
                  to="/member/shop/integral"
                  >{{ currentIntegral }}</router-link
                >
              </div>
            </div>
            <div class="integral-right l">
              <a
                :class="`btn-item btn-integral ${signInFlag}`"
                @click="signIn"
                href="javascript: void(0)"
                >{{signInFlag==='cur'?`已连续签到${continuousSigInDays}天`:'每日签到'}}</a
              >
<!--              {{ signTip }}-->
            </div>
            <div class="e-vip l" v-if="customerInfo.infoIntegrity < 100">
              <a
                class="btn-item btn-vip"
                href="/Rccl.UserCenter/CustomerInfo/editInfo"
                >完善信息领取<span class="cur"><i>200</i>积分</span></a
              >
            </div>
          </div>
          <div class="sign-in-layer" v-if="isSignIn" @click.self="closeSignIn">
            <div class="sign-in">
              <h3 style="margin-top: 27px">
                {{signInFlag==='cur'?`已连续签到${continuousSigInDays}天`:'每日签到'}}
              </h3>
              <a
                class="btn-item btn-close"
                @click="closeSignIn"
                href="javascript: void(0)"
              ></a>
            </div>
          </div>
        </div>
        <!-- recSwiper -->
        <div class="rec-wrap">
          <ul class="fix">
            <li v-for="(item, index) in recBanners" :key="index">
              <a :href="item.Link" @click="showRecommend($event, index)">
                <img :src="item.ImageUrl" :alt="item.Alt" :title="item.Title" />
                <span class="hot" v-if="index == 0">HOT</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="part-shop">
        <ShopRec :rec="shopRec">
          <h3 slot="titleText">积分商城</h3>
          <div class="shop-more r" slot="more">
            <router-link
              tag="a"
              to="/member/shop/index"
              href="javascript: void(0)"
              >查看更多礼品 ></router-link
            >
          </div>
        </ShopRec>
      </div>
      <div class="part-banner">
        <SingleBanner :bannerList="bannerList"></SingleBanner>
      </div>
      <div class="part-question">
        <div class="part-title fix">
          <i class="icon icon-shop l"></i>
          <h3 class="l">会员常见问题<span class="cur">TOP10</span></h3>
          <div class="question-more r">
            <a class="btn-item btn-rule l" href="/content/rewardprivacy_PC"
              >查看“皇家游享荟”项目细则与条款</a
            >
            <a
              class="btn-item btn-more l"
              href="/content/faq?source=LOCAL_REWARD"
              >查看更多会员问题 ></a
            >
          </div>
        </div>
        <div class="question-list">
          <ul class="fix">
            <li
              class="vc"
              v-for="item in questionList"
              :key="item.id"
              @click="showAnswerLayer(item.id)"
            >
              <i class="icon icon-dot"></i>
              <div v-html="item.question"></div>
            </li>
          </ul>
        </div>
        <!-- answer -->
        <div
          class="answer-layer"
          v-if="isShowAnswer"
          @click.self="closeAnswer()"
        >
          <div class="answer-wrap">
            <div class="question-tip vc">
              <i class="icon icon-line"></i>
              <div v-html="selectQuestion.question"></div>
            </div>
            <div class="answer-content" v-html="selectQuestion.answer"></div>
            <a
              class="btn-item btn-close hvc"
              @click="closeAnswer"
              href="javascript: void(0)"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <Loading :loading="loading"></Loading>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import axios from "@/libs/api.request";
import InfoCard from "@/components/info-card/";
import ShopRec from "@/components/shop-rec/";
import SingleBanner from "@/components/single-banner";
import Loading from "@/components/loading";
import { mapMutations } from "vuex";
export default {
  name: "memberCenter",
  components: {
    InfoCard,
    ShopRec,
    SingleBanner,
    Loading,
  },
  data: () => {
    return {
      customerInfo: {},
      privilegeList: [],
      currentIntegral: 0,
      recSwiper: null,
      recBanners: [],
      shopRec: [],
      bannerList: [],
      questionAll: [
				// {
				// 	id: 0,
				// 	question: "3月会员日-积分抢兑活动规则 <span class='hot'>HOT</span>",
				// 	answer: '<p>【积分抢兑】</p>'+
				// 	'<p>1. 活动时间：2021/3/22-2021/3/28</p>'+
				// 	'<p>2. 活动期间，会员至积分商城中使用积分抢兑好礼；</p>'+
				// 	'<p>3. 礼品包括：双人豪华游轮船票 积分秒杀3999分，数量1份；经典黑保温杯 积分秒杀2000积分，数量15个；皇家收纳套装 积分秒杀 1500积分，数量30个；时尚双肩包 积分秒杀 1000积分，数量10个；三网话费充值数字卡券'+
				// 	'  积分秒杀 400积分，数量100个；每天会提供一定数量礼品抢兑，礼品数量有限，先到先得。</p>'+
				// 	'<p>4. 划线积分指积分商城中原礼品的积分兑换分值，秒杀积分指在活动期间内可兑换礼品的分值；</p>'+
				// 	'<p>5. 双人豪华游轮船票说明：指皇家加勒比国际游轮中国大陆母港航次双人阳台房1间（含船票两张），船票获得者需在复航后3个月内联系皇家客服兑换；</p>'+
				// 	'<p style="padding-left: 15px;">1) 适用航次：皇家加勒比国际游轮中国大陆母港航次复航之日（以皇家官方宣布为准）起3个月内的航次，具体的航次和可选舱房由皇家指定，并以客服通知为准。</p>'+
				// 	'<p style="padding-left: 15px;">2) 该奖品仅包括两人的船票费用，不含港务税费及游轮服务费（港务税费根据航次不同有所变化，参考为每人600-800元不等；游轮服务费为每人每晚5美金）。</p>'+
				// 	'<p style="padding-left: 15px;">3)'+
				// 	'  船票获得者需在复航后3个月内联系皇家客服确认是否兑换奖品，确认兑换的应在指定日期前提供出行者名单，自提供之日起不得更改。出行者名单应包括以下完整信息：出行者姓名、性别、出生日期、国籍、联系电话，并提供护照照片页复印件。</p>'+
				// 	'<p style="padding-left: 15px;">4)'+
				// 	'  待皇家客服收到并审查出行者名单后，船票获得者应在收到皇家发出的船舱确认账单后的3个工作日内支付双人港务税费及游轮服务费，以美金支付，中奖者需自备含美金币种的外币信用卡。港务税费及游轮服务费一旦支付不予退款。</p>'+
				// 	'<p style="padding-left: 15px;">5)'+
				// 	'  船票获得者逾期确认或未确认的、逾期提供或未提供或更改出行者名单的、逾期交纳或未交纳相关费用的、取消或要求修改中奖航次的，均视为放弃奖品，皇家不做任何补偿或赔偿，包括不限于中奖者已支付或产生的任何费用，如往返出发地交通费用、签证费、通行证和签注费用等。'+
				// 	'</p>'+
				// 	'<p style="padding-left: 15px;">6)'+
				// 	'  皇家将尽可能提供确认的航次舱房给船票获得者，但因游轮产品的特殊性（如：会因不可抗力而取消航次、航次所有舱房可能提前售完或超售或航次被包船等），可能无法提供该航次舱房；此种情况下，皇家将根据游轮公司实际航线售卖及库存情况，为船票获得者指定其他相同或相似的航线和舱房，中奖者应配合改签，否则即视为放弃奖励舱房，不做任何补偿或赔偿。'+
				// 	'</p>'+
				// 	'<p style="padding-left: 15px;">7) 奖品仅限获得者本人使用，不得转让、转卖、兑换现金或以其他任何方式使用。</p>'+
				// 	'<p style="padding-left: 15px;">8) 该奖品不可与皇家任何其他优惠同享，包括但不限于，现金立减优惠券、船上消费抵用金等。</p>'+
				// 	'<p>6. 皇家加勒比国际游轮在法律允许的范围内对本活动保留解释权。</p>'
				// },
        {
          id: 1,
          question: "什么是“皇家游享荟”？",
          answer:
            '<p>“皇家游享荟”是皇家加勒比国际游轮为中国大陆地区喜爱游轮出行的客人定制的一项全新会员奖励计划，于2020年5月20日正式在中国大陆地区上线。加入皇家游享荟即可通过游轮出行、推荐好友、互动等方式获得积分奖励。更有积分商城兑换心仪好礼！皇家游享荟会员项目相关细则请查看<a href="/content/rewardprivacy_PC" target="_blank">《“皇家游享荟”项目细则与条款》</a></p>',
        },
        {
          id: 2,
          question: "成为“皇家游享荟”会员有什么好处？",
          answer:
            "<p>成为“皇家游享荟”会员后可获得会员专属优惠、消费及互动积分、商城优选好礼、多重惊喜礼遇等诸多福利。</p>",
        },
        {
          id: 3,
          question: "如何累积消费积分？",
          answer:
            '<p>注册成为会员，并完善个人信息，在符合资格的预订下出行预订航次，可累积消费积分，“符合资格的预订”指：</p><p>1) 订单创建时间需晚于2020年5月20日；</p><p>2) 必须为通过皇家中国大陆官方网站、微信小程序、客服电话、飞猪旗舰店（“皇家官方渠道”）、皇家中国母港航次上的未来假期柜台和途易绿洲官网渠道进行的新增预订；任何其他渠道的预订不可积分，包括不限于，旅行社预订、企业或团队预订等；</p><p>3) 预订“皇家加勒比国际游轮”品牌下的中国母港及海外航次，具体以预订当时的在售情况和实际库存为准；</p><p>4)在预订航次离船日起第10天，订单为全款支付状态；在此之前取消的订单将不累积积分。</p><p>消费积分累积的详细规则，请查看<a href="/content/rewardprivacy_PC" target="_blank">《“皇家游享荟”项目细则与条款》</a></p>',
        },
        {
          id: 4,
          question: '如何累积推荐积分？',
          answer:
            '<p>“推荐有礼”活动是指会员通过推荐朋友成为“皇家游享荟”新会员并预订船票来赚取推荐积分的活动。</p><p>1) 推荐人本人需为“皇家游享荟”会员；推荐人将“推荐有礼”活动页面链接或推荐码分享给好友后，好友通过该链接注册成为新会员或使用推荐码注册成为新会员，推荐人可获得10积分，积分于好友成功注册后入账。推荐人每月最多可累积10次该积分，推荐好友成功注册超过10人的，按10人计算；推荐积分的获得数量在活动期间可能有所调整，具体以活动规则为准。</p><p>2)上述好友在注册两年内，首次通过皇家中国大陆官方网站、微信小程序或途易绿洲中国官网完成符合资格的预订，则好友成功出行后，推荐人可获得好友消费积分一半的积分，积分入账一般与好友消费积分入账同步。推荐人每年最多可累积10次该积分，超过10次的，按前10次计算；每间舱房可获得的推荐积分上限为12,500分。</p><p>推荐积分累积的详细规则，请查看<a href="/content/rewardprivacy_PC" target="_blank">《“皇家游享荟”项目细则与条款》</a></p>',
        },
        {
          id: 5,
          question: "积分有效期是多久？",
          answer:
            "<p>自入账之日起至两年后当月的最后一天。例如，2020年6月5日所获得的积分，将在2022年6月31日到期。</p>",
        },
        {
          id: 6,
          question: "注册为会员之前已预订或已出行的航次是否可以累积消费积分？",
          answer:
            "<p>如果已预订或已出行航次的实际预订时间是在2020年5月20日之后，且符合消费积分条件，则在离船日起12个月内，会员可以申请消费积分补登，逾期不予办理，办理过程中，需根据皇家的要求提供相关材料作为办理凭证。</p>",
        },
        {
          id: 7,
          question: "积分有什么用途？",
          answer:
            "<p>积分可在“皇家游享荟”-“积分商城”兑换实物礼品、电子礼品和皇家船票抵用优惠券等。</p>",
        },
        {
          id: 8,
          question: "“皇家游享荟”各会员等级的条件?",
          answer:
            '<p>初级会员: 注册会员即可成为初级会员，在等级有效期内完成0次符合资格的出行</p><p>高级会员: 在等级有效期内完成1次符合资格的出行</p><p>精英会员: 在等级有效期内完成2-3次符合资格的出行</p><p>卓越会员: 在等级有效期内至少完成4次符合资格的出行</p><p>“符合资格的出行”是指：会员出行的航次，属于“符合资格的预订”下的航次，即构成符合资格的出行。</p><p>会员等级的详细规则，请查看<a href="/content/rewardprivacy_PC" target="_blank">《“皇家游享荟”项目细则与条款》</a></p>',
        },
        {
          id: 9,
          question: "我可以享受哪些会员福利？",
          answer:
            '<p>不同等级的会员享受的会员福利不同，“皇家游享荟”会员可在移动端登录网站<a href="https://mobile.www.rcclchina.com.cn/reward">https://mobile.www.rcclchina.com.cn/reward</a>或电脑端登陆网站 <a href="https://www.rcclchina.com.cn/rewardpc">https://www.rcclchina.com.cn/rewardpc</a>的“会员福利”页面查看您当前可享受的会员福利。</p>',
        },
        {
          id: 10,
          question: "“皇冠铁锚俱乐部”里程和权益如何查看？",
          answer:
            '<p>“皇家游轮俱乐部”自2020年5月20日起更名为“皇冠铁锚俱乐部”。“皇冠铁锚俱乐部”是皇家加勒比国际游轮的全球会员项目,“皇家游享荟”则是为中国消费者打造的特色会员项目，目前仅对持有中国大陆手机号的自然人开放注册。如您之前注册过“皇冠铁锚俱乐部”会员，仍可注册“皇家游享荟”会员，同时拥有2个会员身份，同享会员福利，需明确的是，两个会员项目相互独立，积分等不可合并或相互流转。“皇冠铁锚俱乐部”会员可在移动端登录网站<a href="https://mobile.rcclchina.com.cn/reward/member/welfare">https://mobile.rcclchina.com.cn/reward/member/welfare</a>或电脑端登陆网站<a href="https://www.rcclchina.com.cn/rewardpc/member/welfare">https://www.rcclchina.com.cn/rewardpc/member/welfare</a>至“我的福利”-“查看皇冠铁锚俱乐部全球会员权益”，查看相关权益。</p>',
        },
      ],
      questionList: [],
      selectQuestion: {},
      isShowAnswer: false,
      isSignIn: false,
      signInFlag: "",
      signTip: "每日签到",
      signInStatus: 0,
      obtainPoint: 0,
      loading: true,
      continuousSigInDays:''
    };
  },
  beforeRouteEnter(to, from, next) {
    window.console.log(from.path, to.redirectedFrom);
    next(() => {
      if (to.redirectedFrom === "/recommend/courtesy") {
        window.location.reload();
      }
    });
  },
  mounted() {
    // loading
    this.loading = this.$store.state.app.loading;
    // 推荐有礼弹层
    if (this.$route.query.showRec) {
      this.$store.commit("showRecommendLayer", true);
    }

    this.checkCustomerInfo().then((res) => {
      if (!res) {
        let href = window.location.href;
        window.location.href = `/Rccl.UserCenter/CustomerInfo/SignUpReward?returnUrl=${encodeURIComponent(
          href
        )}`;
      }
    });

    this.getUserPoint().then((res) => {
      if (res) {
        this.currentIntegral = res.userPoint;
      }
    });
    //会员信息轮播
    this.getBanner("CustomerCenterEarnPoint_pc")
      .then((res) => {
        this.recBanners = this.sortBanner(res.PictureModels);
      })
      .catch((err) => {
        window.console.log(err);
      });

    // 会员中心底部轮播图
    this.getBanner("CustomerCenterMiddleBanner_pc")
      .then((res) => {
        this.bannerList = this.sortBanner(res.PictureModels);
      })
      .catch((err) => {
        window.console.log(err);
      });
    this.getUserSignIn().then((res) => {
      this.signInStatus = res.signInStatus;
      if (this.signInStatus === 1) {
        this.getSignInCount().then((res)=>{
          this.continuousSigInDays = res
        })
        this.signInFlag = "cur";
        // this.signTip = '已连续签到'+this.continuousSigInDays+'天';
      }
    });
    this.getUserLevelPrivilege().then((res) => {
      this.customerInfo = res.customerInfo;
      this.privilegeList = res.privilegeList;

      this.storeInfo(this.customerInfo);
      this.storePrivilegeList(this.privilegeList);
    });
    this.getUserMobile().then((res) => {
      if (!this.customerInfo.fullName) {
        this.customerInfo.fullName = res.mobile;
        this.customerInfo = Object.assign({}, this.customerInfo);

        // 存储信息
        this.storeInfo(this.customerInfo);
      }
    });
    this.getVipRecommend().then((res) => {
      this.shopRec = res.rows;

      // 清除等待
      // this.loadingHide(false)
      this.loading = false;
    });
    this.initQuestion();
  },
  methods: {
    ...mapMutations(["loadingHide", "storeInfo", "storePrivilegeList"]),
    signIn() {
      if (this.signInStatus) return false;

      this.updatePoint(10002).then((res) => {
        this.signInStatus = 1;
        this.isSignIn = true;
        this.signInFlag = "cur";
        this.currentIntegral += res ? res : 1;
        this.obtainPoint = res ? res : 1;
        this.getSignInCount().then((res)=>{
          this.continuousSigInDays = res
          // this.signTip = '已连续签到'+this.continuousSigInDays+'天';
        })
      });

    },
    closeSignIn() {
      this.isSignIn = false;
    },
    showAnswerLayer(id) {
      this.selectQuestion = this.questionList.find((item) => item.id === id);
      this.isShowAnswer = true;
    },
    closeAnswer() {
      this.isShowAnswer = false;
      this.selectQuestion = {};
    },
    updatePoint(point) {
      return this.updateUserPoint(point);
    },
    initQuestion() {
      this.questionList = this.questionAll;
    },
    showRecommend(e, index) {
      if (index === 0 || index === 2) {
        this.$store.commit("showRecommendLayer", true);
        e.preventDefault();
      }
    },
    getUserPoint() {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/api/CustomerInfo/ApiGetUserPoint",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: {
              loyaltyId: this.$store.state.user.loyaltyId,
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              resolve(data.data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    getUserSignIn() {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/api/CustomerInfo/ApiGetUserSignIn",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: {
              loyaltyId: this.$store.state.user.loyaltyId,
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              resolve(data.data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    updateUserPoint(pointCode) {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/api/CustomerInfo/ApiUpdateUserPoint",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: {
              pointCode,
              loyaltyId: this.$store.state.user.loyaltyId,
              changeChannel: "mobile",
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              this.getSignInCount().then((res)=>{
                this.continuousSigInDays = res
              })
              resolve(data.data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    getUserLevelPrivilege() {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/api/CustomerInfo/ApiGetUserLevelPrivilege",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: {
              loyaltyId: this.$store.state.user.loyaltyId,
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              resolve(data.data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    getVipRecommend() {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/pro/Store/CMProduct/GetVipRecommend",
            method: "get",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            params: {
              v: new Date().getTime(),
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              resolve(data.data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    getBanner(name) {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/pro/Store/CMCommon/GetBannerByName",
            method: "get",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            params: {
              name,
              v: new Date().getTime(),
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              resolve(data.data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    sortBanner(pics) {
      return pics.sort((itemA, itemB) => {
        return itemB.DisplayOrder - itemA.DisplayOrder;
      });
    },
    getUserMobile() {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/Rccl.OpenApi/User/GetUserPoint",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: {
              loyaltyId: this.$store.state.user.loyaltyId,
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.success) {
              resolve(data.data);
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    checkCustomerInfo() {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/api/CustomerInfo/ApiCheckCustomerInfo",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: {
              loyaltyId: this.$store.state.user.loyaltyId,
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              resolve(data.data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    async getSignInCount(){
      return new Promise((resolve) => {
        axios
            .request({
              url: "/api/CustomerInfo/ApiGetUserSignInCnt",
              method: "post",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.$store.state.user.token}`,
              },
              data: {
                loyaltyId: this.$store.state.user.loyaltyId,
              },
            })
            .then((res) => {
              let data = res.data;
              if (data.errCode === 0) {
                this.continuousSigInDays = data.data.continuousSignInCnt
                resolve(data.data.continuousSignInCnt);
              } else if (data.errCode === 1000) {
                window.console.log("失败");
              } else {
                window.console.log("系统错误");
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.member-center {
  padding-bottom: 84px;
  .part-top {
    .info-card-wrap {
      height: 106px;
      background-color: #fff;
    }
    .integral-wrap {
      .part-title {
        padding-top: 30px;
        padding-bottom: 14px;
      }
      .integral-left {
        height: 35px;
        .icon-integral {
          width: 33px;
          height: 33px;
          background: url("../../assets/images/icon_integral.png") no-repeat;
          background-size: cover;
        }
        h3 {
          padding-left: 9px;
          font-size: 22px;
          line-height: 35px;
        }
        .current-integral {
          height: 35px;
          padding-left: 9px;
          line-height: 30px;
          .number-font {
            cursor: pointer;
          }
          .cur {
            position: relative;
            top: 2px;
            color: #ffa70d;
            font-size: 30px;
            font-weight: bold;
          }
        }
      }
      .integral-right {
        padding-left: 14px;
        .btn-integral {
          width: 134px;
          height: 34px;
          background: url("../../assets/images/btn_intrgral.png") no-repeat;
          color: #fff;
          font-size: 16px;
          line-height: 34px;
          text-align: center;
          &.cur {
            background-image: url("../../assets/images/btn_intrgral_cur.png");
            pointer-events: none;
          }
        }
      }
      .e-vip {
        padding-left: 9px;
        .btn-vip {
          width: 240px;
          height: 34px;
          border: #0073bb solid 1px;
          border-radius: 17px;
          color: #0073bb;
          text-align: center;
          line-height: 33px;
          font-size: 16px;
          letter-spacing: 2px;
          .cur {
            font-weight: bold;
            i {
              position: relative;
              top: 1px;
              font-size: 18px;
            }
          }
        }
      }
      .sign-in-layer {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 100;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        .sign-in {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 506px;
          height: 323px;
          margin-left: -132px;
          margin-top: -162px;
          padding-top: 30px;
          background: url("../../assets/images/sign_in_bg.png") no-repeat;
          text-align: center;
          color: #fff;
          p {
            font-size: 30px;
            line-height: 40px;
          }
          h3 {
            display: block;
            height: 42px;
            font-size: 24px;
            font-weight: normal;
            line-height: 42px;
            i {
              margin-right: 8px;
            }
            .cur {
              position: relative;
              top: 4px;
              margin-right: 10px;
              font-size: 48px;
            }
          }
          .btn-close {
            position: absolute;
            left: 50%;
            bottom: -62px;
            width: 46px;
            height: 46px;
            margin-left: -23px;
            background: url("../../assets/images/btn_close.png") no-repeat;
            background-size: cover;
          }
        }
      }
    }
    .rec-wrap {
      li {
        float: left;
        position: relative;
        width: 308px;
        height: 170px;
        margin-right: 13px;
        overflow: hidden;
        img {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 104%;
          max-width: none;
          margin-left: -6px;
        }
        &:last-child {
          margin-right: 0;
        }
        .hot {
          width: 59px;
          height: 24px;
          border-bottom-left-radius: 8px;
          color: #fff;
          text-align: center;
          line-height: 24px;
          background-color: #ff0000;
          color: #ffffff;
          position: absolute;
          right: 0px;
        }
      }
    }
  }
  .part-question {
    .part-title {
      padding-top: 30px;
      padding-bottom: 14px;
      .icon-shop {
        width: 33px;
        height: 33px;
        background: url("../../assets/images/icon_question.png") no-repeat;
        background-size: 100% 100%;
      }
      h3 {
        padding-left: 9px;
        font-size: 22px;
        line-height: 35px;
        .cur {
          padding-left: 10px;
          color: #ffa80f;
        }
      }
      .question-more {
        .btn-more {
          height: 35px;
          color: #4a90e2;
          line-height: 40px;
        }
        .btn-rule {
          height: 35px;
          margin-right: 16px;
          color: #4a90e2;
          line-height: 40px;
        }
      }
    }
    .question-list {
      border: #d4dbde solid 1px;
      background-color: #fff;
      ul {
        padding: 26px 82px 6px 20px;
				display: flex;
				justify-content: space-between;
				flex-flow: row wrap;
        li {
          // float: left;
          width: 50%;
          margin-bottom: 20px;
          line-height: 22px;
          cursor: pointer;
					flex: 0 0 50%;
          .icon-dot {
            width: 2px;
            height: 2px;
            margin-right: 4px;
            border-radius: 50%;
            background-color: #282b2c;
          }
        }
      }
    }
    .answer-layer {
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 100;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      .answer-wrap {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 801px;
        padding: 22px 36px 46px;
        margin-left: -274px;
        background-color: #fff;
        border-radius: 4px;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        .question-tip {
          font-size: 22px;
          color: #282b2c;
          line-height: 34px;
        }
        .answer-content {
          padding-top: 12px;
          color: #747d80;
          line-height: 22px;
        }
        .btn-close {
          position: absolute;
          right: 10px;
          top: 10px;
          width: 29px;
          height: 29px;
          background: url("../../assets/images/close.png") no-repeat center
            center #d3dadd;
          background-size: 16px 16px;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>


<style lang="less">
.member-center {
  .question-list {
    .vc {
      .hot {
        background: #ff0000;
        color: white;
        padding: 2px 5px;
        border-radius: 9px;
        font-size: 13px;
      }
    }
  }
  .answer-layer {
    .question-tip {
      .hot {
        background: #ff0000;
        color: white;
        padding: 3px 6px;
        border-radius: 15px;
        font-size: 13px;
        vertical-align: middle;
      }
    }
  }
}
</style>